// extracted by mini-css-extract-plugin
module.exports = {"ShareButton":"SocialShareButtons_ShareButton__3Hrax","ButtonText":"SocialShareButtons_ButtonText__3I4Ty"};